import type { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { Button, Dialog, ShieldWarningIcon } from "@/shared/ui";

export const DisqualifiedAlert = ({
  ...props
}: ComponentProps<typeof Dialog.Root>) => {
  return (
    <Dialog.Root alert {...props}>
      <Dialog.Content withCloseButton={false}>
        <Dialog.Header icon={ShieldWarningIcon}>
          <Dialog.Title>{t`Almost there!`}</Dialog.Title>

          <Dialog.Description>
            {t`Looks like you've got 3 or more injections left.`}
            <br />
            {t`Please come back when you have 2 or fewer, and we'll be ready to help you out!`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button size="lg" asChild>
            <Link to={ROUTES.MY_MEDS}>{t`Got it, back to My Meds`}</Link>
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
